import type { JSX } from "react";
import type { LoomGuideBlock as LoomGuideBlockModel } from "@shared/types";
import type { BlockRendererProps } from "./registry";

/**
 * loom-guide 块渲染器（L2 · FEATURE_IA_LOOM_GUIDE）：帮用户"找到/到达"织灵页面 ——
 * 一张真实页面截图（若有）+ 一个跳转真实织灵页面的深链。不渲染/不内嵌 loom UI；
 * 链接落在用户自己那套织灵，角色/租户/版本天然正确。label/url/screenshot 由后端
 * 按 loomweb 路由清单解析（见 server/agent/blocks/loom-guide.ts）。
 */
export function LoomGuideBlockView({ block }: BlockRendererProps): JSX.Element {
  const g = block as LoomGuideBlockModel;
  return (
    <div className="loom-guide">
      {g.title !== undefined && g.title.length > 0 && (
        <div className="loom-guide-head">
          <span className="loom-guide-tag">页面引导</span>
          {g.title}
        </div>
      )}
      {g.screenshot !== undefined && g.screenshot.length > 0 && (
        <img className="loom-guide-shot" src={g.screenshot} alt={`${g.label} 截图`} loading="lazy" />
      )}
      <a className="loom-guide-link" href={g.url} target="_blank" rel="noreferrer noopener">
        <span className="loom-guide-link-label">去{g.label}</span>
        <span className="loom-guide-link-arrow" aria-hidden="true">→</span>
      </a>
      {g.caption !== undefined && g.caption.length > 0 && (
        <div className="loom-guide-caption">{g.caption}</div>
      )}
    </div>
  );
}
